<template>
  <div class="page page--traffic-cam">
    <div v-for="item in roads" :key="item.name" class="page-transport-block" style="background-color: #064870" v-on:click="onItemClick(item)">
      <div :data-picurl="item.url" class="page--traffic-cam__contain">
        <div class="page--traffic-cam__title">
          <span>SH{{item.roadId}} {{item.name}}</span>
          <span class="page--traffic-cam__icon">{{item.roadId}}</span>
        </div>
        <div class="page--traffic-cam__subtitle">{{item.bound}}bound</div>
      </div>
    </div>
    <div v-if="isShow" class="show-pic modal-backdrop" v-on:click="onCloseModal">
        <img :src="showPicUrl" alt="" class="modal-body">
    </div>
  </div>
</template>


<script>
  export default {
    name: 'EstimateTravelTimes',
    data() {
      return {
        roads: [
        {url:"https://www.trafficnz.info/camera/110.jpg", name:"Bairds Rd Overbridge", bound:"North", roadId:"1"},
        {url:"https://www.trafficnz.info/camera/90.jpg", name:"South Eastern Hwy", bound:"South", roadId:"1"},
        {url:"https://www.trafficnz.info/camera/80.jpg", name:"Greenlane Interchange", bound:"North", roadId:"1"},
        {url:"https://www.trafficnz.info/camera/100.jpg", name:"Redoubt Rd", bound:"North", roadId:"1"},
        {url:"https://www.trafficnz.info/camera/290.jpg", name:"Massey Rd", bound:"North", roadId:"20"},
        {url:"https://www.trafficnz.info/camera/619.jpg", name:"Bader Dr Overbridge", bound:"South", roadId:"20"},
        {url:"https://www.trafficnz.info/camera/206.jpg", name:"Puhinui Rd", bound:"South", roadId:"20"},
        {url:"https://www.trafficnz.info/camera/212.jpg", name:"Interchange South", bound:"South", roadId:"1"},
        {url:"https://www.trafficnz.info/camera/210.jpg", name:"Barrowcliffe Pl Overbridge", bound:"North", roadId:"20"},
      ],
      isShow: false,
      showPicUrl: ""
      }
    },
    methods: {
      onItemClick: function(item) {
        this.showPicUrl = item.url
        this.isShow = true
      },
      onCloseModal: function() {
        this.isShow = false
      }
    }
  }
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.page-transport-block {
  text-align: center;
  box-shadow: 0 1rem 1rem rgba(0,0,0,0.2);
  padding: 2rem;
  background-color: #7a7a7a;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-decoration: none;
  @media screen and (max-width: $screen-md-max) {
    padding: 1rem;
  }
}

.page--traffic-cam {
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(4, 1fr);

  @media screen and (max-width: $screen-md-max) {
    grid-template-columns: 1fr;
  }
}

.page--traffic-cam__contain {
  color: white;
  text-align: left;
}

.page--traffic-cam__title {
  display:flex;
  justify-content: space-between;
  text-align: left;
}

.page--traffic-cam__icon {
  font-size: 0.5em;
  min-width: 35px;
  background-size: contain;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAzMiAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDM0Qy00Ljk5OTkgMzQgMS4wMDAwNCAwLjUwMDAwMiAxLjAwMDA0IDAuNTAwMDAySDMwQzMwIDAuNTAwMDAyIDM3IDM0IDE2IDM0WiIgZmlsbD0iI0M4NDI0NSIvPgo8L3N2Zz4K");
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  background-position: center;
  font-weight: bold;
}

.page--traffic-cam__subtitle {
  font-size: 0.7em;
  justify-items: left;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-body {
  width: calc(100vw - 40px);
}
</style>
